module.exports = __webpack_public_path__ + "c329d3d011780626962904a7ba09a3a1.svg";